// extracted by mini-css-extract-plugin
export default {"wrap":"Qo-z","logoContainer":"Ro-z","brandImg":"So-z","logoImg":"To-z","logoButton":"Uo-z"};